import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';
import {
  Button,
  Popover,
  List,
  ListItem,
  ListItemIcon,
  Checkbox, ListItemText, Typography
} from '@material-ui/core';

import { useSelector } from 'react-redux';
import { KeyboardArrowDown } from '@material-ui/icons';

const useStyles = makeStyles({
  listItemIcon: {
    minWidth: 'unset'
  },
  checkbox: {
    '&:hover': {
      background: 'transparent'
    }
  },
  listItemText: {
    fontSize: 14
  }
}, { name: 'CategoryFilter' });

const CategoryFilter = ({
  categoryFilters,
  handleCategoryFilter
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const categories = useSelector(state => state.accountInfo.categories);

  const [ anchor, setAnchor ] = useState(null);

  return (
    <>
      <Button
        onClick={ e => setAnchor(e.currentTarget) }
        className='CategoryFilter-buton'
        startIcon={
          <Checkbox
            color="primary"
            checked={ !!categoryFilters.length }
            disableRipple
            className={ classes.checkbox }
          />
        }
        endIcon={ <KeyboardArrowDown /> }
      >
        <Typography className={ classes.listItemText }>
          { t('objective.listHeader.category') }
        </Typography>
      </Button>
      <Popover
        open={ !!anchor }
        anchorEl={ anchor }
        onClose={ () => setAnchor(null) }
      >
        <List className='Category-list'>
          {/*Ez az elem szűr arra, ha nincs egy célnak kategóriája.*/}
          <ListItem
            onClick={ () => handleCategoryFilter('') }
            button
          >
            <ListItemIcon className={ classes.listItemIcon }>
              <Checkbox
                color="primary"
                checked={ categoryFilters.includes('') }
                disableRipple
                className={ classes.checkbox }
              />
            </ListItemIcon>
            <ListItemText className={ classes.listItemText }>
              -
            </ListItemText>
          </ListItem>
          {(categories ?? []).map(category => (
            <ListItem
              key={ category }
              onClick={ () => handleCategoryFilter(category.category_name.hu) }
              button
            >
              <ListItemIcon className={ classes.listItemIcon }>
                <Checkbox
                  color="primary"
                  checked={ categoryFilters.includes(category.category_name.hu) }
                  disableRipple
                  className={ classes.checkbox }
                  value={ category.category_name.hu }
                />
              </ListItemIcon>
              <ListItemText className={ classes.listItemText }>
                {category.category_name.hu}
              </ListItemText>
            </ListItem>
          ))}
        </List>
      </Popover>
    </>
  );
};

export default CategoryFilter;
